export const ADD_TABS = 'ADD_TABS'; // Tab添加
export const REMOVE_TAB = 'REMOVE_TAB'; // Tab删除
export const SELECTED_TABLE = 'SELECTED_TABLE'; // 线索穿梭框内容
export const ADD_HOME = 'ADD_HOME'; // 首页添加内容

export const CURRENT_SUB_MENU = 'CURRENT_SUB_MENU'; // 电话呼入信息

export const CURRENT_MENU = "CURRENT_MENU";     //面包屑

export const BREADCRUMB_MENU = "BREADCRUMB_MENU";     //面包屑
export const PROJECTLIST = "PROJECTLIST";     //项目科目列表

export const KNOWLEDGE_DIALOG = "KNOWLEDGE_DIALOG";     //选择知识点弹层

export const COURSE_COVER = "COURSE_COVER";     //选择知识点弹层
export const RESOURCE_INTRO = "RESOURCE_INTRO";     //保存资源介绍的信息
export const RESOURCE_UPDATE = "RESOURCE_UPDATE";     //保存修改过的资源介绍的信息
export const COURSE_INFO = "COURSE_INFO";     //保存课程的所有信息
export const COURSE_SYLLABUSES = "COURSE_SYLLABUSES";     //保存课程下的大纲Syllabuses

export const GET_USER_TREE = "GET_USER_TREE"


// WEBPACK FOOTER //
// ./src/js/store/mutation-types.js